// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  OrientationVersion,
  ScriptActionEntry,
} from "./types";

export default {
  stepId: __t.string(),
  get orientationVersion() {
    return OrientationVersion;
  },
  get entries() {
    return __t.array(ScriptActionEntry);
  },
};
